var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WatchCardDel',{attrs:{"name":_vm.name},on:{"on-close":_vm.onClose,"on-delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }